import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import { PushNotifications } from '@capacitor/push-notifications'
import store from '@/store'


/**
* @Description
* 
* 1. This module is common and shared for logging out user from one point
* 2. If first gets the device id and worker UUID and dispatch a request to backend to clear login period accociated temp data
* 3. It clears the local storage and refresh the page to login view
* 
* @params none
* @return void
**/
const logout = async() => {

  const info = await Device.getId()

  let payload = {
    worker_id : store.getters.EMPLOYEE_UUID,
    device_id : info?.identifier
  }

  store.commit('SET_FCM_TOKEN_REGISTERD', false)

  try {
    await store.dispatch('HTTP_POST_REQUEST', { url: `/employee/logout`, payload: payload })
  } catch (err) {
    console.log(err)
  }

  if (Capacitor.isNativePlatform()) {
    try {
      await PushNotifications.unregister()
    } catch (err) {
      console.log(err)
    }
  }

  localStorage.clear()
  window.location.href = '/'

}

export default logout